/* Modulo: Clip Showcase — tap-to-lightbox (uploaded MP4 + YouTube/Vimeo) + carousel arrows.
   Vanilla IIFE, lazy-init, reduced-motion aware. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }

  function initSection(section) {
    /* ─── Carousel arrows ─── */
    var grid = section.querySelector('[data-csh-grid]');
    var prev = section.querySelector('[data-csh-prev]');
    var next = section.querySelector('[data-csh-next]');

    if (grid && (prev || next)) {
      var step = function () {
        var card = grid.querySelector('.modulo-csh__card');
        var gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : grid.clientWidth * 0.8;
      };
      var sync = function () {
        var max = grid.scrollWidth - grid.clientWidth - 2;
        var fits = max <= 2;
        if (prev) prev.disabled = fits || grid.scrollLeft <= 2;
        if (next) next.disabled = fits || grid.scrollLeft >= max;
      };
      var behavior = REDUCE ? 'auto' : 'smooth';
      if (prev) prev.addEventListener('click', function () { grid.scrollBy({ left: -step() * 2, behavior: behavior }); });
      if (next) next.addEventListener('click', function () { grid.scrollBy({ left: step() * 2, behavior: behavior }); });
      grid.addEventListener('scroll', sync, { passive: true });
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(sync, 100); });
      sync();
    }

    /* ─── Lightbox ─── */
    var lightbox = section.querySelector('[data-csh-lightbox]');
    var lbBody = section.querySelector('[data-csh-lightbox-body]');
    var lbCap = section.querySelector('[data-csh-lightbox-cap]');
    var lbClose = section.querySelector('[data-csh-lightbox-close]');
    if (!lightbox || !lbBody) return;

    function buildMedia(card) {
      var kind = card.getAttribute('data-csh-kind');
      if (kind === 'video') {
        var raw = card.getAttribute('data-csh-sources');
        var sources;
        try { sources = JSON.parse(raw || '[]'); } catch (e) { sources = []; }
        if (!sources.length) return null;
        var v = document.createElement('video');
        v.setAttribute('controls', '');
        v.setAttribute('autoplay', '');
        v.setAttribute('playsinline', '');
        var poster = card.getAttribute('data-csh-poster');
        if (poster) v.setAttribute('poster', poster);
        for (var i = 0; i < sources.length; i++) {
          if (!sources[i] || !sources[i].src) continue;
          var s = document.createElement('source');
          s.src = sources[i].src;
          if (sources[i].type) s.type = sources[i].type;
          v.appendChild(s);
        }
        return v;
      }
      if (kind === 'embed') {
        var url = card.getAttribute('data-csh-embed');
        if (!url) return null;
        var f = document.createElement('iframe');
        f.src = url;
        f.setAttribute('allow', 'autoplay; fullscreen; encrypted-media');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', 'Video player');
        return f;
      }
      return null;
    }

    function buildCaption(card) {
      if (!lbCap) return;
      clear(lbCap);
      var handle = card.getAttribute('data-csh-handle');
      if (!handle) return;
      var link = card.getAttribute('data-csh-link');
      var node;
      if (link) {
        node = document.createElement('a');
        node.href = link;
        node.target = '_blank';
        node.rel = 'noopener nofollow';
      } else {
        node = document.createElement('span');
      }
      node.textContent = handle;
      lbCap.appendChild(node);
    }

    function open(card) {
      var media = buildMedia(card);
      if (!media) return;
      clear(lbBody);
      lbBody.appendChild(media);
      buildCaption(card);
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lightbox._prev = document.activeElement;
      if (lbClose) lbClose.focus();
      if (media.tagName === 'VIDEO' && media.play) {
        var p = media.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function close() {
      if (lightbox.getAttribute('aria-hidden') === 'true') return;
      lightbox.setAttribute('aria-hidden', 'true');
      clear(lbBody);
      if (lbCap) clear(lbCap);
      document.body.style.overflow = '';
      if (lightbox._prev && lightbox._prev.focus) lightbox._prev.focus();
    }

    var cards = section.querySelectorAll('[data-csh-card]');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        card.addEventListener('click', function () { open(card); });
      })(cards[i]);
    }

    if (lbClose) lbClose.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') close();
    });
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-csh]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-csh]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
